import { render, staticRenderFns } from "./ProductBreadcrumbs.vue?vue&type=template&id=b91a4fdc&scoped=true&"
import script from "./ProductBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./ProductBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./ProductBreadcrumbs.vue?vue&type=style&index=0&id=b91a4fdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91a4fdc",
  null
  
)

export default component.exports